import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useFetch from "shared/model/useFetch"

const useGetEventDetail = () => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/admin/event/${idx}/detail`)
    }, [])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 404:
                setAlert("대회 데이터가 존재하지 않습니다.")
                navigate("/select")
                break
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetEventDetail